/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChecklistItem } from './ChecklistItem';
import {
    ChecklistItemFromJSON,
    ChecklistItemFromJSONTyped,
    ChecklistItemToJSON,
    ChecklistItemToJSONTyped,
} from './ChecklistItem';

/**
 * 
 * @export
 * @interface GetChecklistResponse
 */
export interface GetChecklistResponse {
    /**
     * 
     * @type {Array<ChecklistItem>}
     * @memberof GetChecklistResponse
     */
    items: Array<ChecklistItem>;
}

/**
 * Check if a given object implements the GetChecklistResponse interface.
 */
export function instanceOfGetChecklistResponse(value: object): value is GetChecklistResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetChecklistResponseFromJSON(json: any): GetChecklistResponse {
    return GetChecklistResponseFromJSONTyped(json, false);
}

export function GetChecklistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChecklistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ChecklistItemFromJSON)),
    };
}

  export function GetChecklistResponseToJSON(json: any): GetChecklistResponse {
      return GetChecklistResponseToJSONTyped(json, false);
  }

  export function GetChecklistResponseToJSONTyped(value?: GetChecklistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ChecklistItemToJSON)),
    };
}

